import * as React from "react";
import { useParams } from "react-router-dom";
import { useWorkspace } from "@/context/workspace";
import { PanelGroup, Panel, PanelResizeHandle } from "react-resizable-panels";
import TopBar from "../components/TopBar";
import FlowFSList from "../components/FlowFSList";
import DetailsPanel from "../components/DetailsPanel";
import UploadZone from "../components/UploadZone";
import { useFlowFSStore } from "../state/flowfs-store";
import { useShallow } from "zustand/react/shallow";

export default function FlowFilesPage() {
  const { flowId = "" } = useParams<{ flowId: string }>();
  const { active: ws } = useWorkspace();
  const tenantId = ws?.id ?? "";
  const { prefix, recursive, limit, cursor, setCursor } = useFlowFSStore(
    useShallow((s) => ({
      prefix: s.prefix,
      recursive: s.recursive,
      limit: s.limit,
      cursor: s.cursor,
      setCursor: s.setCursor,
    }))
  );

  if (!tenantId || !flowId) {
    return <div className="p-3 text-sm">Loading…</div>;
  }

  return (
    <div className="h-full w-full flex flex-col">
      <TopBar tenantId={tenantId} flowId={flowId} />
      <div className="flex-1">
        <PanelGroup direction="horizontal" className="h-full">
          <Panel minSize={40}>
            <div className="h-full flex flex-col">
              <UploadZone tenantId={tenantId} flowId={flowId} />
              <FlowFSList
                tenantId={tenantId}
                flowId={flowId}
                prefix={prefix}
                recursive={recursive}
                limit={limit}
                cursor={cursor}
                onCursorChange={setCursor}
              />
            </div>
          </Panel>
          <PanelResizeHandle className="w-2 bg-border hover:bg-accent transition-colors cursor-col-resize flex items-center justify-center">
            <div className="w-1 h-8 bg-muted-foreground/30 rounded-full" />
          </PanelResizeHandle>
          <Panel minSize={24} defaultSize={32}>
            <DetailsPanel tenantId={tenantId} flowId={flowId} />
          </Panel>
        </PanelGroup>
      </div>
    </div>
  );
}
